import { render } from "./VisitorTable.vue?vue&type=template&id=87ccaf02"
import script from "./VisitorTable.vue?vue&type=script&lang=js"
export * from "./VisitorTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__